// import React, { useState, useEffect } from 'react';
// import { postData } from '../../../../../Services/Fetchnodeservices';

// export default function LockerToBank({ isDark }) {
//     const [lockerItems, setLockerItems] = useState([]);
//     const [selectedIds, setSelectedIds] = useState([]);
//     const [staffList, setStaffList] = useState([]);
//     const [loading, setLoading] = useState(true);
    
//     // Form State
//     const [tripData, setTripData] = useState({
//         staff1: '',
//         staff2: '',
//         bankName: ''
//     });

//     useEffect(() => {
//         fetchLockerData();
//         fetchStaffData();
//     }, []);

//     const fetchLockerData = async () => {
//         setLoading(true);
//         // Fetch only verified cash that hasn't been sent to bank yet
//         const res = await postData("vandersuperadmin/admin/cash/verified-deposits", {});
//         if (res.success) {
//             // Filter out items already in transit if backend doesn't handle it
//             setLockerItems(res.data || []);
//         }
//         setLoading(false);
//     };

//     const fetchStaffData = async () => {
//         const res = await postData("vandersuperadmin/admin/fetch-all-staff", {});
//         if (res.success) setStaffList(res.data || []);
//     };

//     const toggleSelection = (id) => {
//         setSelectedIds(prev => 
//             prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
//         );
//     };

//     const handleHandover = async () => {
//         if (selectedIds.length === 0) return alert("Please select at least one collection");
//         if (!tripData.staff1 || !tripData.bankName) return alert("Please select Staff 1 and Target Bank");
//         if (tripData.staff1 === tripData.staff2) return alert("Staff 1 and Staff 2 cannot be the same person");

//         const confirm = window.confirm(`Confirm handover of ₹${totalSelectedAmount} to ${tripData.staff1}?`);
//         if (!confirm) return;

//         const res = await postData("vandersuperadmin/admin/cash/initiate-bank-trip", {
//             totalAmount: totalSelectedAmount,
//             staffId1: tripData.staff1,
//             staffId2: tripData.staff2 || null,
//             bankName: tripData.bankName,
//             collectionIds: selectedIds
//         });

//         if (res.success) {
//             alert("Handover Successful! Trip started.");
//             setTripData({ staff1: '', staff2: '', bankName: '' });
//             setSelectedIds([]);
//             fetchLockerData();
//         } else {
//             alert(res.message || "Failed to initiate trip");
//         }
//     };

//     const totalSelectedAmount = lockerItems
//         .filter(item => selectedIds.includes(item.collection_id))
//         .reduce((sum, curr) => sum + Number(curr.cash_amount), 0);

//     const colors = {
//         bg: isDark ? "#111827" : "#fff",
//         border: isDark ? "#1f2937" : "#e5e7eb",
//         text: isDark ? "#fff" : "#111827",
//         card: isDark ? "#1a1f2e" : "#f9fafb"
//     };

//     if (loading) return <div style={{ padding: 40, textAlign: 'center' }}>Loading Locker Data...</div>;

//     return (
//         <div style={{ padding: 25, color: colors.text, fontFamily: "'DM Sans', sans-serif" }}>
//             <h2 style={{ marginBottom: 10 }}>🏦 Office Locker Management</h2>
//             <p style={{ color: '#6b7280', marginBottom: 25 }}>Select verified cash collections to handover to staff for bank deposit.</p>

//             <div style={{ display: 'grid', gridTemplateColumns: '1fr 350px', gap: 20 }}>
//                 {/* Left Side: Collection Table */}
//                 <div style={{ background: colors.bg, border: `1px solid ${colors.border}`, borderRadius: 12, padding: 20 }}>
//                     <h4 style={{ marginBottom: 15 }}>Verified Cash in Locker</h4>
//                     <table width="100%" style={{ borderCollapse: 'collapse' }}>
//                         <thead>
//                             <tr style={{ textAlign: 'left', borderBottom: `2px solid ${colors.border}` }}>
//                                 <th style={{ padding: 12 }}>Select</th>
//                                 <th style={{ padding: 12 }}>Collection ID</th>
//                                 <th style={{ padding: 12 }}>Driver</th>
//                                 <th style={{ padding: 12 }}>Amount</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {lockerItems.length === 0 ? (
//                                 <tr><td colSpan="4" style={{ textAlign: 'center', padding: 20 }}>No verified cash in locker.</td></tr>
//                             ) : (
//                                 lockerItems.map(item => (
//                                     <tr key={item.collection_id} style={{ borderBottom: `1px solid ${colors.border}` }}>
//                                         <td style={{ padding: 12 }}>
//                                             <input 
//                                                 type="checkbox" 
//                                                 checked={selectedIds.includes(item.collection_id)}
//                                                 onChange={() => toggleSelection(item.collection_id)}
//                                                 style={{ width: 18, height: 18 }}
//                                             />
//                                         </td>
//                                         <td style={{ padding: 12 }}>#{item.collection_id}</td>
//                                         <td style={{ padding: 12 }}>{item.driver_name}</td>
//                                         <td style={{ padding: 12, fontWeight: 'bold', color: '#16a34a' }}>₹{item.cash_amount}</td>
//                                     </tr>
//                                 ))
//                             )}
//                         </tbody>
//                     </table>
//                 </div>

//                 {/* Right Side: Handover Form */}
//                 <div style={{ background: colors.card, border: `1px solid ${colors.border}`, borderRadius: 12, padding: 20, height: 'fit-content' }}>
//                     <h4 style={{ marginBottom: 20 }}>Handover Details</h4>
                    
//                     <div style={{ marginBottom: 15 }}>
//                         <label style={{ fontSize: 13, fontWeight: 600 }}>Total Selected Amount</label>
//                         <div style={{ fontSize: 28, fontWeight: 'bold', color: '#16a34a', marginTop: 5 }}>
//                             ₹{totalSelectedAmount.toLocaleString()}
//                         </div>
//                     </div>

//                     <div style={{ marginBottom: 15 }}>
//                         <label style={{ fontSize: 13, fontWeight: 600 }}>Staff Member 1 (Main)</label>
//                         <select 
//                             value={tripData.staff1}
//                             onChange={(e) => setTripData({...tripData, staff1: e.target.value})}
//                             style={{ width: '100%', padding: 10, borderRadius: 8, marginTop: 5, border: `1px solid ${colors.border}` }}
//                         >
//                             <option value="">Select Staff 1</option>
//                             {staffList.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
//                         </select>
//                     </div>

//                     <div style={{ marginBottom: 15 }}>
//                         <label style={{ fontSize: 13, fontWeight: 600 }}>Staff Member 2 (Security)</label>
//                         <select 
//                             value={tripData.staff2}
//                             onChange={(e) => setTripData({...tripData, staff2: e.target.value})}
//                             style={{ width: '100%', padding: 10, borderRadius: 8, marginTop: 5, border: `1px solid ${colors.border}` }}
//                         >
//                             <option value="">Select Staff 2 (Optional)</option>
//                             {staffList.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
//                         </select>
//                     </div>

//                     <div style={{ marginBottom: 25 }}>
//                         <label style={{ fontSize: 13, fontWeight: 600 }}>Target Bank Name</label>
//                         <input 
//                             type="text" 
//                             placeholder="e.g. SBI, HDFC..."
//                             value={tripData.bankName}
//                             onChange={(e) => setTripData({...tripData, bankName: e.target.value})}
//                             style={{ width: '100%', padding: 10, borderRadius: 8, marginTop: 5, border: `1px solid ${colors.border}` }}
//                         />
//                     </div>

//                     <button 
//                         onClick={handleHandover}
//                         disabled={selectedIds.length === 0}
//                         style={{ 
//                             width: '100%', 
//                             padding: 12, 
//                             background: selectedIds.length === 0 ? '#9ca3af' : '#2563eb', 
//                             color: '#fff', 
//                             border: 'none', 
//                             borderRadius: 8, 
//                             cursor: 'pointer',
//                             fontWeight: 'bold'
//                         }}
//                     >
//                         Confirm Handover
//                     </button>
//                 </div>
//             </div>
//         </div>
//     );
// }
import React, { useState, useEffect, useContext } from 'react';
import { ThemeContext } from "../../../../../context/ThemeContext";
import { postData } from '../../../../../services/Fetchnodeservices';

// ===================== ICONS =====================
const WalletIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M22 6v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z" />
    <path d="M22 10h-4a2 2 0 0 0-2 2v0a2 2 0 0 0 2 2h4" />
    <circle cx="18" cy="14" r="1" fill="currentColor" />
  </svg>
);

const UserIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

const BankIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <polygon points="12 2 2 7 22 7" />
    <line x1="2" y1="22" x2="22" y2="22" />
    <line x1="4" y1="7" x2="4" y2="22" />
    <line x1="20" y1="7" x2="20" y2="22" />
    <line x1="8" y1="7" x2="8" y2="22" />
    <line x1="12" y1="7" x2="12" y2="22" />
    <line x1="16" y1="7" x2="16" y2="22" />
  </svg>
);

const TruckIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <rect x="1" y="3" width="15" height="13" />
    <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
    <circle cx="5.5" cy="18.5" r="2.5" />
    <circle cx="18.5" cy="18.5" r="2.5" />
  </svg>
);

const CheckIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const ClockIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

const ShieldIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);

// ===================== STAT CARD =====================
const StatCard = ({ icon, title, value, color, theme }) => (
  <div
    style={{
      background: theme.surface,
      padding: 20,
      borderRadius: 16,
      boxShadow: `0 4px 12px ${theme.primary}10`,
      border: `1px solid ${theme.border}`,
      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = 'translateY(-2px)';
      e.currentTarget.style.boxShadow = `0 8px 25px ${theme.primary}20`;
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = 'translateY(0)';
      e.currentTarget.style.boxShadow = `0 4px 12px ${theme.primary}10`;
    }}
  >
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
      <div
        style={{
          width: 44,
          height: 44,
          borderRadius: 12,
          background: `${color}1a`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: color,
        }}
      >
        {icon}
      </div>
      <h4 style={{ margin: 0, fontSize: 12, color: theme.textSecondary, fontWeight: 500 }}>
        {title}
      </h4>
    </div>
    <h2 style={{ margin: 0, fontSize: 24, fontWeight: 700, color: theme.textPrimary }}>
      {value}
    </h2>
  </div>
);

// ===================== STATUS BADGE =====================
const StatusBadge = ({ status, theme }) => {
  const getStatusConfig = (statusValue) => {
    const statusStr = String(statusValue || '').toLowerCase();
    const statusMap = {
      'deposited': { bg: `${theme.success}1a`, color: theme.success, label: 'Deposited' },
      'in_transit': { bg: `${theme.warning}1a`, color: theme.warning, label: 'In Transit' },
      'pending': { bg: `${theme.warning}1a`, color: theme.warning, label: 'Pending' },
      'cancelled': { bg: `${theme.error || theme.danger}1a`, color: theme.error || theme.danger, label: 'Cancelled' },
    };
    return statusMap[statusStr] || statusMap['pending'];
  };

  const c = getStatusConfig(status);

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '4px 12px',
        borderRadius: 20,
        fontSize: 11,
        fontWeight: 700,
        background: c.bg,
        color: c.color,
      }}
    >
      <span style={{ width: 6, height: 6, borderRadius: '50%', background: c.color }} />
      {c.label}
    </span>
  );
};

// ===================== MAIN COMPONENT =====================
export default function LockerToBank() {
  const { theme } = useContext(ThemeContext); // ← Theme Context

  const [lockerItems, setLockerItems] = useState([]);
  const [history, setHistory] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [staffList, setStaffList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tripData, setTripData] = useState({ staff1: '', staff2: '', bankName: '' });

  useEffect(() => {
    fetchAllData();
  }, []);

  const fetchAllData = async () => {
    setLoading(true);
    const resLocker = await postData("vandersuperadmin/admin/cash/locker-balance", {});
    const resStaff = await postData("vandersuperadmin/admin/fetch-all-staff", {});
    const resHistory = await postData("vandersuperadmin/admin/cash/handover-history", {});

    if (resLocker.success) setLockerItems(resLocker.data || []);
    if (resStaff.success) setStaffList(resStaff.data || []);
    if (resHistory.success) setHistory(resHistory.data || []);
    setLoading(false);
  };

  const handleHandover = async () => {
    if (selectedIds.length === 0) return alert("Select at least one collection");
    if (!tripData.staff1 || !tripData.bankName) return alert("Select Staff 1 and Bank");

    const totalAmount = lockerItems
      .filter(i => selectedIds.includes(i.collection_id))
      .reduce((sum, curr) => sum + Number(curr.cash_amount), 0);

    const res = await postData("vandersuperadmin/admin/cash/initiate-bank-trip", {
      totalAmount,
      staffId1: tripData.staff1,
      staffId2: tripData.staff2 || null,
      bankName: tripData.bankName,
      collectionIds: selectedIds
    });

    if (res.success) {
      alert("Handover Confirmed! Paisa Locker se Transit mein chala gaya.");
      setSelectedIds([]);
      setTripData({ staff1: '', staff2: '', bankName: '' });
      fetchAllData();
    } else {
      alert(res.message || res.error || "Unable to start bank trip");
    }
  };

  const toggleSelection = (collectionId) => {
    setSelectedIds(prev =>
      prev.includes(collectionId)
        ? prev.filter(i => i !== collectionId)
        : [...prev, collectionId]
    );
  };

  const selectAll = () => {
    if (selectedIds.length === lockerItems.length) {
      setSelectedIds([]);
    } else {
      setSelectedIds(lockerItems.map(item => item.collection_id));
    }
  };

  // Stats calculations
  const totalLockerAmount = lockerItems.reduce((sum, item) => sum + Number(item.cash_amount || 0), 0);
  const selectedAmount = lockerItems
    .filter(i => selectedIds.includes(i.collection_id))
    .reduce((sum, curr) => sum + Number(curr.cash_amount), 0);
  const totalTrips = history.length;
  const totalDeposited = history
    .filter(h => h.status === 'DEPOSITED')
    .reduce((sum, h) => sum + Number(h.total_amount || 0), 0);

  return (
    <div style={{ padding: 24, minHeight: '100vh', background: theme.background, fontFamily: "'DM Sans', sans-serif", transition: 'background 0.3s ease' }}>
      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
      `}</style>

      {/* Header */}
      <div style={{ marginBottom: 24 }}>
        <h2 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: theme.textPrimary, display: 'flex', alignItems: 'center', gap: 10 }}>
          🏦 Office Locker Management
        </h2>
        <p style={{ color: theme.textMuted, margin: '4px 0 0', fontSize: 13 }}>
          Manage cash in locker and initiate bank handover trips
        </p>
      </div>

      {/* Stats Cards */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
          gap: 16,
          marginBottom: 24,
        }}
      >
        <StatCard
          icon={<WalletIcon />}
          title="Locker Balance"
          value={`₹ ${totalLockerAmount.toLocaleString()}`}
          color={theme.primary}
          theme={theme}
        />
        <StatCard
          icon={<TruckIcon />}
          title="Selected Amount"
          value={`₹ ${selectedAmount.toLocaleString()}`}
          color={theme.warning}
          theme={theme}
        />
        <StatCard
          icon={<BankIcon />}
          title="Total Trips"
          value={totalTrips}
          color={theme.success}
          theme={theme}
        />
        <StatCard
          icon={<ShieldIcon />}
          title="Total Deposited"
          value={`₹ ${totalDeposited.toLocaleString()}`}
          color={theme.success}
          theme={theme}
        />
      </div>

      {/* Main Grid */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 380px', gap: 20, marginBottom: 32 }}>
        {/* Selection Table */}
        <div
          style={{
            background: theme.surface,
            border: `1px solid ${theme.border}`,
            borderRadius: 16,
            padding: 24,
            boxShadow: `0 4px 12px ${theme.primary}08`,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <h4 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: theme.textPrimary }}>
              ✅ Verified Cash in Locker (Ready for Bank)
            </h4>
            {lockerItems.length > 0 && (
              <button
                onClick={selectAll}
                style={{
                  padding: '6px 14px',
                  background: selectedIds.length === lockerItems.length ? `${theme.error || theme.danger}1a` : `${theme.primary}1a`,
                  color: selectedIds.length === lockerItems.length ? (theme.error || theme.danger) : theme.primary,
                  border: 'none',
                  borderRadius: 8,
                  cursor: 'pointer',
                  fontSize: 11,
                  fontWeight: 600,
                  transition: 'all 0.2s ease',
                }}
              >
                {selectedIds.length === lockerItems.length ? '✕ Deselect All' : '✓ Select All'}
              </button>
            )}
          </div>

          {loading ? (
            <div style={{ textAlign: 'center', padding: 40 }}>
              <div
                style={{
                  width: 32,
                  height: 32,
                  border: `3px solid ${theme.border}`,
                  borderTopColor: theme.primary,
                  borderRadius: '50%',
                  margin: '0 auto 12px',
                  animation: 'spin 1s linear infinite',
                }}
              />
              <p style={{ color: theme.textSecondary, fontSize: 13 }}>Loading locker items...</p>
            </div>
          ) : lockerItems.length === 0 ? (
            <div style={{ textAlign: 'center', padding: 60 }}>
              <div
                style={{
                  width: 60,
                  height: 60,
                  borderRadius: '50%',
                  background: `${theme.primary}1a`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 16px',
                  color: theme.primary,
                }}
              >
                <WalletIcon />
              </div>
              <h3 style={{ color: theme.textPrimary, marginBottom: 8, fontSize: 16 }}>
                No Cash in Locker
              </h3>
              <p style={{ color: theme.textMuted, fontSize: 13, margin: 0 }}>
                All verified cash has been handed over
              </p>
            </div>
          ) : (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ background: theme.surfaceLighter, borderBottom: `2px solid ${theme.border}` }}>
                    <th style={{ padding: '12px 16px', textAlign: 'left', fontSize: 11, fontWeight: 700, color: theme.primary }}>Select</th>
                    <th style={{ padding: '12px 16px', textAlign: 'left', fontSize: 11, fontWeight: 700, color: theme.primary }}>Collection ID</th>
                    <th style={{ padding: '12px 16px', textAlign: 'left', fontSize: 11, fontWeight: 700, color: theme.primary }}>Driver</th>
                    <th style={{ padding: '12px 16px', textAlign: 'left', fontSize: 11, fontWeight: 700, color: theme.primary }}>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {lockerItems.map(item => {
                    const isSelected = selectedIds.includes(item.collection_id);
                    return (
                      <tr
                        key={item.collection_id}
                        style={{
                          borderBottom: `1px solid ${theme.border}`,
                          background: isSelected ? `${theme.primary}08` : 'transparent',
                          transition: 'background 0.2s ease',
                        }}
                        onMouseEnter={(e) => {
                          if (!isSelected) e.currentTarget.style.background = theme.surfaceHover || `${theme.primary}08`;
                        }}
                        onMouseLeave={(e) => {
                          if (!isSelected) e.currentTarget.style.background = 'transparent';
                        }}
                      >
                        <td style={{ padding: '12px 16px' }}>
                          <input
                            type="checkbox"
                            checked={isSelected}
                            onChange={() => toggleSelection(item.collection_id)}
                            style={{
                              width: 16,
                              height: 16,
                              cursor: 'pointer',
                              accentColor: theme.primary,
                            }}
                          />
                        </td>
                        <td style={{ padding: '12px 16px', fontSize: 13, color: theme.primary, fontFamily: 'monospace', fontWeight: 600 }}>
                          #{item.collection_id}
                        </td>
                        <td style={{ padding: '12px 16px', fontSize: 13, color: theme.textPrimary, fontWeight: 500 }}>
                          {item.driver_name || '-'}
                        </td>
                        <td style={{ padding: '12px 16px', fontSize: 14, color: theme.success, fontWeight: 700 }}>
                          ₹{Number(item.cash_amount || 0).toLocaleString()}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}

          {/* Selected Summary */}
          {selectedIds.length > 0 && (
            <div
              style={{
                marginTop: 16,
                padding: 14,
                background: `${theme.primary}12`,
                border: `1px solid ${theme.primary}30`,
                borderRadius: 10,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <span style={{ fontSize: 13, color: theme.textPrimary }}>
                <strong style={{ color: theme.primary }}>{selectedIds.length}</strong> collections selected
              </span>
              <span style={{ fontSize: 14, fontWeight: 700, color: theme.success }}>
                Total: ₹ {selectedAmount.toLocaleString()}
              </span>
            </div>
          )}
        </div>

        {/* Handover Form */}
        <div
          style={{
            background: theme.surface,
            border: `1px solid ${theme.border}`,
            borderRadius: 16,
            padding: 24,
            height: 'fit-content',
            boxShadow: `0 4px 12px ${theme.primary}08`,
          }}
        >
          <h4 style={{ margin: '0 0 20px', fontSize: 16, fontWeight: 700, color: theme.textPrimary, display: 'flex', alignItems: 'center', gap: 8 }}>
            <TruckIcon /> Handover Details
          </h4>

          {/* Staff 1 */}
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 12, fontWeight: 600, color: theme.textSecondary, display: 'flex', alignItems: 'center', gap: 6, marginBottom: 6 }}>
              <UserIcon /> Staff 1 (Main) <span style={{ color: theme.error || theme.danger }}>*</span>
            </label>
            <select
              value={tripData.staff1}
              onChange={e => setTripData({ ...tripData, staff1: e.target.value })}
              style={{
                width: '100%',
                padding: '10px 12px',
                borderRadius: 8,
                border: `1px solid ${theme.border}`,
                background: theme.surface,
                color: theme.textPrimary,
                fontSize: 13,
                outline: 'none',
                cursor: 'pointer',
                transition: 'border-color 0.2s ease',
              }}
              onFocus={(e) => e.currentTarget.style.borderColor = theme.primary}
              onBlur={(e) => e.currentTarget.style.borderColor = theme.border}
            >
              <option value="">Select Staff</option>
              {staffList.map(s => (
                <option key={s.id} value={s.id}>{s.name}</option>
              ))}
            </select>
          </div>

          {/* Staff 2 */}
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 12, fontWeight: 600, color: theme.textSecondary, display: 'flex', alignItems: 'center', gap: 6, marginBottom: 6 }}>
              <ShieldIcon /> Staff 2 (Security) <span style={{ fontSize: 10, color: theme.textMuted }}>(Optional)</span>
            </label>
            <select
              value={tripData.staff2}
              onChange={e => setTripData({ ...tripData, staff2: e.target.value })}
              style={{
                width: '100%',
                padding: '10px 12px',
                borderRadius: 8,
                border: `1px solid ${theme.border}`,
                background: theme.surface,
                color: theme.textPrimary,
                fontSize: 13,
                outline: 'none',
                cursor: 'pointer',
                transition: 'border-color 0.2s ease',
              }}
              onFocus={(e) => e.currentTarget.style.borderColor = theme.primary}
              onBlur={(e) => e.currentTarget.style.borderColor = theme.border}
            >
              <option value="">Select Staff (Optional)</option>
              {staffList.map(s => (
                <option key={s.id} value={s.id}>{s.name}</option>
              ))}
            </select>
          </div>

          {/* Bank Name */}
          <div style={{ marginBottom: 20 }}>
            <label style={{ fontSize: 12, fontWeight: 600, color: theme.textSecondary, display: 'flex', alignItems: 'center', gap: 6, marginBottom: 6 }}>
              <BankIcon /> Bank Name <span style={{ color: theme.error || theme.danger }}>*</span>
            </label>
            <input
              type="text"
              placeholder="e.g. SBI, HDFC"
              value={tripData.bankName}
              onChange={e => setTripData({ ...tripData, bankName: e.target.value })}
              style={{
                width: '100%',
                padding: '10px 12px',
                borderRadius: 8,
                border: `1px solid ${theme.border}`,
                background: theme.surface,
                color: theme.textPrimary,
                fontSize: 13,
                outline: 'none',
                transition: 'border-color 0.2s ease',
                boxSizing: 'border-box',
              }}
              onFocus={(e) => e.currentTarget.style.borderColor = theme.primary}
              onBlur={(e) => e.currentTarget.style.borderColor = theme.border}
            />
          </div>

          {/* Submit Button */}
          <button
            onClick={handleHandover}
            disabled={selectedIds.length === 0 || !tripData.staff1 || !tripData.bankName}
            style={{
              width: '100%',
              padding: 14,
              background: (selectedIds.length === 0 || !tripData.staff1 || !tripData.bankName)
                ? theme.textMuted
                : theme.primary,
              color: '#fff',
              border: 'none',
              borderRadius: 10,
              cursor: (selectedIds.length === 0 || !tripData.staff1 || !tripData.bankName) ? 'not-allowed' : 'pointer',
              fontSize: 13,
              fontWeight: 700,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 8,
              transition: 'all 0.2s ease',
              boxShadow: (selectedIds.length === 0 || !tripData.staff1 || !tripData.bankName)
                ? 'none'
                : `0 4px 12px ${theme.primary}40`,
              opacity: (selectedIds.length === 0 || !tripData.staff1 || !tripData.bankName) ? 0.6 : 1,
            }}
            onMouseEnter={(e) => {
              if (selectedIds.length > 0 && tripData.staff1 && tripData.bankName) {
                e.currentTarget.style.transform = 'translateY(-1px)';
                e.currentTarget.style.boxShadow = `0 6px 16px ${theme.primary}60`;
              }
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = (selectedIds.length === 0 || !tripData.staff1 || !tripData.bankName)
                ? 'none'
                : `0 4px 12px ${theme.primary}40`;
            }}
          >
            <TruckIcon /> Confirm Handover
          </button>

          {/* Warning Message */}
          {(selectedIds.length === 0 || !tripData.staff1 || !tripData.bankName) && (
            <p style={{ margin: '12px 0 0', fontSize: 11, color: theme.warning, textAlign: 'center' }}>
              ⚠️ Select collections, Staff 1 and Bank to proceed
            </p>
          )}
        </div>
      </div>

      {/* History Table */}
      <div
        style={{
          background: theme.surface,
          border: `1px solid ${theme.border}`,
          borderRadius: 16,
          padding: 24,
          boxShadow: `0 4px 12px ${theme.primary}08`,
        }}
      >
        <h4 style={{ margin: '0 0 16px', fontSize: 16, fontWeight: 700, color: theme.textPrimary, display: 'flex', alignItems: 'center', gap: 8 }}>
          <ClockIcon /> Handover & Transit History
        </h4>

        {loading ? (
          <div style={{ textAlign: 'center', padding: 40 }}>
            <div
              style={{
                width: 32,
                height: 32,
                border: `3px solid ${theme.border}`,
                borderTopColor: theme.primary,
                borderRadius: '50%',
                margin: '0 auto 12px',
                animation: 'spin 1s linear infinite',
              }}
            />
            <p style={{ color: theme.textSecondary, fontSize: 13 }}>Loading history...</p>
          </div>
        ) : history.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 60 }}>
            <div
              style={{
                width: 60,
                height: 60,
                borderRadius: '50%',
                background: `${theme.primary}1a`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 16px',
                color: theme.primary,
              }}
            >
              <ClockIcon />
            </div>
            <h3 style={{ color: theme.textPrimary, marginBottom: 8, fontSize: 16 }}>
              No Handover History
            </h3>
            <p style={{ color: theme.textMuted, fontSize: 13, margin: 0 }}>
              No bank trips have been initiated yet
            </p>
          </div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: theme.surfaceLighter, borderBottom: `1px solid ${theme.border}` }}>
                  <th style={{ padding: '12px 16px', textAlign: 'left', fontSize: 11, fontWeight: 700, color: theme.primary }}>Trip ID</th>
                  <th style={{ padding: '12px 16px', textAlign: 'left', fontSize: 11, fontWeight: 700, color: theme.primary }}>Amount</th>
                  <th style={{ padding: '12px 16px', textAlign: 'left', fontSize: 11, fontWeight: 700, color: theme.primary }}>Staff</th>
                  <th style={{ padding: '12px 16px', textAlign: 'left', fontSize: 11, fontWeight: 700, color: theme.primary }}>Bank</th>
                  <th style={{ padding: '12px 16px', textAlign: 'left', fontSize: 11, fontWeight: 700, color: theme.primary }}>Date</th>
                  <th style={{ padding: '12px 16px', textAlign: 'left', fontSize: 11, fontWeight: 700, color: theme.primary }}>Status</th>
                </tr>
              </thead>
              <tbody>
                {history.map(h => (
                  <tr
                    key={h.id}
                    style={{
                      borderBottom: `1px solid ${theme.border}`,
                      transition: 'background 0.2s ease',
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.background = theme.surfaceHover || `${theme.primary}08`)
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.background = 'transparent')
                    }
                  >
                    <td style={{ padding: '12px 16px', fontSize: 13, color: theme.primary, fontFamily: 'monospace', fontWeight: 600 }}>
                      #{h.id}
                    </td>
                    <td style={{ padding: '12px 16px', fontSize: 14, fontWeight: 700, color: theme.success }}>
                      ₹{Number(h.total_amount || 0).toLocaleString()}
                    </td>
                    <td style={{ padding: '12px 16px', fontSize: 13, color: theme.textPrimary }}>
                      {h.staff_1 || '-'}
                      {h.staff_2 && <span style={{ color: theme.textMuted }}> & {h.staff_2}</span>}
                    </td>
                    <td style={{ padding: '12px 16px', fontSize: 13, color: theme.textSecondary }}>
                      {h.bank_name || '-'}
                    </td>
                    <td style={{ padding: '12px 16px', fontSize: 12, color: theme.textMuted }}>
                      {new Date(h.created_at).toLocaleDateString()}
                    </td>
                    <td style={{ padding: '12px 16px' }}>
                      <StatusBadge status={h.status} theme={theme} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
